import { render, staticRenderFns } from "./menuManage.vue?vue&type=template&id=af8381a6&scoped=true"
import script from "./menuManage.vue?vue&type=script&lang=js"
export * from "./menuManage.vue?vue&type=script&lang=js"
import style0 from "./menuManage.vue?vue&type=style&index=0&id=af8381a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8381a6",
  null
  
)

export default component.exports